/* eslint-disable */
import { SvgIcon } from '@mui/material'
import React from 'react'

export const DirtyMark: React.FC<{ inheritColor?: boolean }> = ({ inheritColor }) => {
  return (
    <SvgIcon viewBox="0 0 20 24" fontSize="inherit" color={inheritColor ? 'inherit' : 'primary'}>
      <path d="M8.45143 18.4417V13.71L4.32191 16.0759L2.77335 13.3659L6.85984 11L2.77335 8.63415L4.32191 5.92416L8.45143 8.29002V3.55829H11.5916V8.29002L15.6781 5.92416L17.2266 8.63415L13.1401 11L17.2266 13.3659L15.6781 16.0759L11.5916 13.71V18.4417H8.45143Z" />
    </SvgIcon>
  )
}
